import axios from "axios";
import { Config } from "../types";
import { getDomain } from "../utils/stringUtils";

export const getConfig = async (): Promise<Config> => {
  try {
    const { data } = await axios.get<Config>(
      `${
        process.env.REACT_APP_API
      }/landing-page-proxy/api/agent-config?domain=${getDomain()}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};
